const conditions = Object.freeze({
  SKIP: 'skip',
  SHOW: 'show',
});

export const { SKIP, SHOW } = conditions;
